import classNames from 'classnames';
import PropTypes from 'prop-types';
import { MFLink } from '@medifind/shared-basic-components'; // Importing Link from wouter
import BreadCrumb from '../../../shared-basic-components/src/lib/BreadCrumb';
import { BreadcrumbJsonLd } from './BreadcrumbJsonLd';
import styles from './BreadcrumbLinks.module.scss';

const BreadcrumbLinks = ({ items = [] }) => {
  const filteredItems = items.filter(Boolean);
  // If one of the names is null, prevent the display and wait until the data loads for it
  if (filteredItems.some((d) => !d.name)) return null;
  return (
    <nav aria-label="breadcrumb" className={styles['breadcrumb-container']}>
      <BreadcrumbJsonLd
        itemListElements={filteredItems.map((item, i) => ({
          position: i + 1,
          name: item.name,
          href: item.link,
        }))}
      />
      <ol className={styles['breadcrumb']}>
        {filteredItems.map((item, index) => {
          const isLastItem = index === filteredItems.length - 1;

          return (
            <li
              key={index}
              className={classNames(styles[`breadcrumb-item`], isLastItem && styles['active'])}
              aria-current={isLastItem ? 'page' : undefined}
            >
              {isLastItem ? (
                item.name
              ) : (
                <MFLink className={styles[`breadcrumb-item ${isLastItem ? 'active' : ''}`]} to={item.link}>
                  {item.name}
                </MFLink>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

BreadCrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};

export { BreadcrumbLinks as default, BreadcrumbLinks };
